<template lang="pug">
b-row
  b-col(cols="12")
    //- form-wizard.wizard-vertical.mb-3(
    //-   color="#498ceb",
    //-   layout="horizontal",
    //-   :title="null",
    //-   :subtitle="null",
    //-   :finish-button-text="$t('message.submit')",
    //-   :back-button-text="$t('message.previous')",
    //-   :next-button-text="$t('message.next')",
    //-   :hide-buttons="readOnly",
    //-   ref="complaintForm"
    //- )
    // Title
    h4(v-if="data.state || data.stage" slot="title", class="pt-1 mb-2")
      span(v-if="data.state")
        span
          | {{ $t('improvement_opp.state') }} &#11166;
        span(:class="data.state === 'completed' ? 'text-success' : data.state === 'delayed' ? 'text-danger' : 'text-primary'", style="font-weight: 600")
          | {{ $t(data.state) }}
        span(v-if="data.state === 'completed' && data.isCompletedOverdue", class="text-danger", style="font-weight: 600")
          |  ({{ $t('delayed') }})
      span(v-if="data.state && data.stage", class="mx-1")  |
      span(v-if="data.stage")
        span
          | {{ $t('actualStage') }} &#11166;
        span(class="text-primary", style="font-weight: 600")
          | {{ $t(`complaintStages.${data.stage}`) }}

    // Early finish notification
    div(v-if="data.finishData", class="early-finish-notice mt-3 mb-3")
      h5.mb-2.text-center
        | {{ $t('message.early_finish_notice_complaint') }}
      b-row
        b-col(md="12")
          b-form-group(:label="$t('label.Justification')", :label-for="$t('label.Justification')")
            div(class="print-text")
              | {{ data.finishData.justification }}

    // Buttons personalization
    //- template(v-slot:footer="slotProps")
    //-   div(class="wizard-footer d-flex justify-content-between align-items-center")
    //-     b-button(
    //-       v-if="!readOnly"
    //-       variant="outline-secondary"
    //-       @click="goToPreviousTab"
    //-       :disabled="slotProps.activeTabIndex === 0"
    //-     )
    //-       | < &nbsp; {{ $t('message.previous') }}

    //-     div(class="ml-auto d-flex align-items-center")
    //-       b-button(
    //-         v-if="!readOnly && !slotProps.isLastStep"
    //-         variant="primary"
    //-         class="mr-2"
    //-         @click="goToNextTab"
    //-       )
    //-         | {{ $t('message.next') }} &nbsp; >

    //-       b-button(
    //-         v-if="!readOnly"
    //-         variant="success"
    //-         @click="handleSubmit"
    //-       )
    //-         | {{ $t('message.submit') }}

    // Identification
    div(:title="$t('label.identification')")
      h4.mt-1.mb-2.print-title
        | {{ $t('label.identification') }}
      validation-observer(ref="identificationTab", tag="form")
        b-row
          // Description
          b-col(md="12")
            b-form-group(:label="$t(`label.${data.type === 'karinLaw' ? 'factsThatAreReported' : 'complaint'}`)", :label-for="$t('label.complaint')")
              //- b-form-textarea(v-model="data.description", :disabled="true")
              div(class="print-text")
                | {{ data.description }}
        
        b-row
          // Themes
          b-col(md="6")
            b-form-group(:label="$t('label.themes')", :label-for="$t('label.themes')")
              validation-provider(:name="$t('label.themes')", rules="required", v-slot="{ errors }")
                b-form-input(v-model="data.themesComputed", trim, :disabled="true")
                small(class="text-danger") {{ errors[0] }}
        
          // Document
          b-col(md="6")
            b-form-group(:label="$t(`label.${data.type === 'karinLaw' ? 'additionalBackground' : 'document'}`)", :label-for="$t('label.document')")
              // Open Document
              b-button(
                v-if="data.documentKey && data.documentKey.length"
                class="mr-1"
                type="button"
                variant="success"
                @click="openDocument(data.documentKey)"
              )
                | {{ $t('message.open') }}

              // No document message
              b-form-input(
                v-else
                v-model="noDocumentMessage"
                :disabled="true"
              )

        b-row
          // Associated Cases
          //- b-col(md="6")
          //-   b-form-group(:label="$t('label.associated_cases')", :label-for="$t('label.associated_cases')")
          //-     v-select(
          //-       v-model="data.associatedCases"
          //-       label="title"
          //-       :multiple="!readOnly && stages[data.stage] <= 2"
          //-       :options="improvements"
          //-       :reduce="improvement => improvement.value"
          //-       :disabled="readOnly || stages[data.stage] > 2"
          //-       :placeholder="$t('placeholder.associated_cases')"
          //-     )

          // Link to Associated Case
          //- b-col(md="6")
          //-   b-form-group(:label="$t('label.associated_case_link')", :label-for="$t('label.associated_case_link')")
          //-     b-button(
          //-       variant="warning"
          //-       size="sm"
          //-       :style="{ marginTop: '4px' }"
          //-       :disabled="readOnly || !data.associatedCase"
          //-       @click="openCase(data.associatedCase)"
          //-     )
          //-       | {{ $t('message.see_case') }}
        
          // Company Relationship
          b-col(md="6")
            b-form-group(:label="$t(`label.${data.type === 'karinLaw' ? 'organizationalLinkBetweenTheParties' : 'companyRelationship'}`)", :label-for="$t('label.companyRelationship')")
              b-form-input(v-model="data.companyRelationshipComputed", trim, :disabled="true")

          // Company
          b-col(md="6")
            b-form-group(:label="$t('label.company')", :label-for="$t('label.company')")
              v-select(
                v-model="data.company"
                label="title"
                :options="companies"
                :reduce="company => company.value"
                :disabled="true"
              )

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.identificationTab", tab="identificationTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Responsibles
    div(:title="$t('message.responsibles')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.responsibles') }}
      validation-observer(ref="responsiblesTab", tag="form") 
        b-row(v-if="data.type !== 'karinLaw'")
          // Operational Areas
          b-col(md="12")
            b-form-group(:label="$t('label.operationalAreas')", :label-for="$t('label.operationalAreas')")
              v-select(
                v-model="data.areas"
                label="title"
                :options="locations"
                :reduce="location => location.value"
                :disabled="true"
              )

        b-row(v-if="data.type !== 'karinLaw'")
          // Reported Person
          b-col(md="6")
            b-form-group(:label="$t('label.reported_person')", :label-for="$t('label.reported_person')")
              validation-provider(:name="$t('label.reported_person')", rules="required", v-slot="{ errors }")
                v-select(
                  v-model="data.reportedPerson"
                  label="title"
                  :options="workersTotal"
                  :reduce="worker => worker.value"
                  :disabled="true"
                )
                small(class="text-danger") {{ errors[0] }}
          
          // Reported Person Responsible
          b-col(md="6")
            b-form-group(:label="$t('label.reported_person_responsible')", :label-for="$t('label.reported_person_responsible')")
              v-select(
                v-model="data.reportedPersonResponsible"
                label="title"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :disabled="true"
              )

        b-row(v-if="data.type === 'karinLaw'")
          // Author
          b-col(md="4")
            b-form-group(:label="$t('label.whistleblower')" label-for="whistleblower" label-class="font-weight-bold")
              // Name
              label {{ $t('label.Name') }}
              div
                validation-provider(:name="`${$t('label.Name')} 1`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.author.name"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.name')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // RUT
              label {{ $t('message.tableHeader.rut') }}
              div
                validation-provider(:name="`${$t('message.tableHeader.rut')} 1`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.author.rut"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.rut')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // Email
              label {{ $t('label.Email') }}
              div
                validation-provider(:name="`${$t('label.Email')} 1`" rules="required|email" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.author.email"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.email')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // Company
              label {{ $t('label.company') }}
              div
                validation-provider(:name="`${$t('label.company')} 1`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.author.company"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.company')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // User Number
              label {{ $t('message.user_number') }}
              b-form-input(
                v-model="data.authorUserNumber"
                trim
                :disabled="true"
              )

          // Affected Person
          b-col(md="4")
            b-form-group(:label="$t('label.affectedPerson')" label-for="affectedPerson" label-class="font-weight-bold")
              // Name
              label {{ $t('label.Name') }}
              div
                validation-provider(:name="`${$t('label.Name')} 2`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.affectedPerson.name"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.name')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // RUT
              label {{ $t('message.tableHeader.rut') }}
              b-form-input(
                v-model="data.affectedPerson.rut"
                trim
                :disabled="true"
                :placeholder="$t('placeholder.rut')"
              )

              // Email
              label {{ $t('label.Email') }}
              div
                validation-provider(:name="`${$t('label.Email')} 2`" rules="required|email" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.affectedPerson.email"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.email')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // Company
              label {{ $t('label.company') }}
              div
                validation-provider(:name="`${$t('label.company')} 2`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.affectedPerson.company"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.company')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // User Number
              label {{ $t('message.user_number') }}
              b-form-input(
                v-model="data.affectedUserNumber"
                trim
                :disabled="true"
              )

          // Reported Person
          b-col(md="4")
            b-form-group(:label="$t('label.reported_person')" label-for="reported_person" label-class="font-weight-bold")
              // Name
              label {{ $t('label.Name') }}
              div
                validation-provider(:name="`${$t('label.Name')} 3`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.reportedPersonData.name"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.name')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // RUT
              label {{ $t('message.tableHeader.rut') }}
              b-form-input(
                v-model="data.reportedPersonData.rut"
                trim
                :disabled="true"
                :placeholder="$t('placeholder.rut')"
              )

              // Email
              label {{ $t('label.Email') }}
              div
                validation-provider(:name="`${$t('label.Email')} 3`" rules="email" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.reportedPersonData.email"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.email')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // Position
              label {{ $t('label.position') }}
              div
                validation-provider(:name="`${$t('label.position')} 3`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.reportedPersonData.position"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.position')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // Company
              label {{ $t('label.company') }}
              div
                validation-provider(:name="`${$t('label.company')} 3`" rules="required" v-slot="{ errors }")
                  b-form-input(
                    v-model="data.reportedPersonData.company"
                    trim
                    :disabled="true"
                    :placeholder="$t('placeholder.company')"
                  )
                  small(class="text-danger") {{ errors[0] }}

              // User Number
              label {{ $t('message.user_number') }}
              b-form-input(
                v-model="data.reportedUserNumber"
                trim
                :disabled="true"
              )
        
        b-row
          // Registration Responsible (Complainant Number)
          b-col(md="6")
            b-form-group(:label="$t('label.registration_responsible_complainant_number')", :label-for="$t('label.registration_responsible_complainant_number')")
              b-form-input(
                v-model="data.caseNumber",
                trim,
                :disabled="true"
              )

          // Date
          b-col(md="3")
            b-form-group(:label="$t('label.date')", :label-for="$t('label.date')")
              flat-pickr(
                v-model="data.createdAt"
                :config="flatPickrConfig"
                class="form-control"
                :disabled="true"
              )

        b-row
          // Proposal Responsible
          b-col(md="6")
            b-form-group(:label="$t('label.investigation_responsible')", :label-for="$t('label.investigation_responsible')")
              validation-provider(:name="$t('label.investigation_responsible')", rules="required", v-slot="{ errors }")
                v-select(
                  v-model="data.proposalResponsible"
                  label="title"
                  :options="workersTotal"
                  :selectable="worker => !worker.deleted"
                  :reduce="worker => worker.value"
                  :disabled="readOnly || stages[data.stage] > 2"
                  :placeholder="$t('placeholder.investigation_responsible')"
                )
                small(class="text-danger") {{ errors[0] }}

          // Due date for proposal responsible
          b-col(md="3")
            b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
              flat-pickr(
                v-model="data.dueDate"
                :config="flatPickrConfig"
                class="form-control"
                :disabled="true"
              )

          // Business days
          b-col(md="2")
            b-form-group
              label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                span {{ $t('message.duration') }}
                InformationButton.py-0(text="message.businessDaysDifference")

              b-form-input(
                :value="proposalBusinessDays"
                disabled
              )

        b-row
          // Approval Responsible
          b-col(md="6")
            b-form-group(:label="$t('label.investigation_approval_responsible')", :label-for="$t('label.investigation_approval_responsible')")
              v-select(
                v-model="data.approvalResponsible"
                label="title"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :disabled="readOnly || stages[data.stage] > 2"
                :placeholder="$t('placeholder.investigation_approval_responsible')"
              )

          // Due date for approval responsible
          b-col(md="3")
            b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
              flat-pickr(
                v-model="data.approvalDueDate"
                :config="flatPickrConfig"
                class="form-control"
                :disabled="readOnly || stages[data.stage] > 2"
              )

          // Business days
          b-col(md="2")
            b-form-group
              label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                span {{ $t('message.duration') }}
                InformationButton.py-0(text="message.businessDaysDifference")

              b-form-input(
                :value="approvalBusinessDays"
                disabled
              )

        b-row
          // Verification Responsible
          b-col(md="6")
            b-form-group(:label="$t('label.verification_responsible')", :label-for="$t('label.verification_responsible')")
              v-select(
                v-model="data.verificationResponsible"
                label="title"
                :multiple="!readOnly && stages[data.stage] <= 2"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :disabled="readOnly || stages[data.stage] > 2"
                :placeholder="$t('placeholder.verification_responsible')"
              )

          // Due date for verification responsible
          b-col(md="3")
            b-form-group(:label="$t('label.due_date')", :label-for="$t('label.due_date')")
              flat-pickr(
                v-model="data.verificationDueDate"
                :config="flatPickrConfig"
                class="form-control"
                :disabled="readOnly || stages[data.stage] > 2"
              )

          // Business days
          b-col(md="2")
            b-form-group
              label.col-form-label.d-flex.align-items-center.py-0(:style="{ marginBottom: '4px' }")
                span {{ $t('message.duration') }}
                InformationButton.py-0(text="message.businessDaysDifference")

              b-form-input(
                :value="verificationBusinessDays"
                disabled
              )
        
        b-row(v-if="data.type !== 'karinLaw'")
          // Author User Number
          b-col(md="4")
            b-form-group(:label="$t('label.author_user_number')", :label-for="$t('label.author_user_number')")
              b-form-input(
                v-model="data.authorUserNumber",
                trim,
                :disabled="true"
              )
          
          // Affected User Number
          b-col(md="4")
            b-form-group(:label="$t('label.affected_user_number')", :label-for="$t('label.affected_user_number')")
              b-form-input(
                v-model="data.affectedUserNumber",
                trim,
                :disabled="true"
              )
          
          // Reported User Number
          b-col(md="4")
            b-form-group(:label="$t('label.reported_user_number')", :label-for="$t('label.reported_user_number')")
              b-form-input(
                v-model="data.reportedUserNumber",
                trim,
                :disabled="true"
              )

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.responsiblesTab", tab="responsiblesTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Analysis
    div(v-if="(readOnly || stages[data.stage] >= 3) && actionPlans.length", :title="$t('message.investigation')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.investigation') }}
      validation-observer(ref="analysisTab", tag="form")
        // Problem
        b-row
          b-col(md="6")
            h5
              | {{ $t('label.Problem') }}
        b-row
          b-col(md="12")
            b-form-group
              small.text-muted
                | {{ $t('message.complaint_analysis') }}
              //- b-form-textarea(v-model="data.problemStatement", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis", :placeholder="$t('message.describe_complaint_analysis')")
              div(class="print-text")
                | {{ data.problemStatement }}

        // 5 Why Methodology
        b-row.mt-1
          b-col(md="12")
            b-form-group(label="" label-for="5WhyMethodology")
              b-form-checkbox(id="checkbox-1", v-model="fiveWhyMethodEnabled", name="checkbox-1", :value="true", :unchecked-value="false")
                span.font-weight-bold {{ $t('label.WhyMethod') }}
        
        // 5 whys
        b-row(v-if="fiveWhyMethodEnabled")
          b-col(md="4")
            b-form-group(:label="$t('label.Why1')", :label-for="$t('label.Why1')")
              //- b-form-textarea(v-model="data.why1", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis", :placeholder="$t('placeholder.first_cause')")
              div(class="print-text")
                | {{ data.why1 }}
              b-form-checkbox(v-model="data.rootCause" :value="1" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why2')", :label-for="$t('label.Why2')")
              //- b-form-textarea(v-model="data.why2", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 2", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why2 }}
              b-form-checkbox(v-model="data.rootCause" :value="2" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why3')", :label-for="$t('label.Why3')")
              //- b-form-textarea(v-model="data.why3", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 3", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why3 }}
              b-form-checkbox(v-model="data.rootCause" :value="3" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why4')", :label-for="$t('label.Why4')")
              //- b-form-textarea(v-model="data.why4", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 4", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why4 }}
              b-form-checkbox(v-model="data.rootCause" :value="4" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why5')", :label-for="$t('label.Why5')")
              //- b-form-textarea(v-model="data.why5", :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis || data.rootCause < 5", :placeholder="$t('placeholder.root_cause')")
              div(class="print-text")
                | {{ data.why5 }}
              b-form-checkbox(v-model="data.rootCause" :value="5" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis")
                small
                  | {{ $t('label.rootCause') }}
        
        // Action Plans Title
        b-row(class="mt-1")
          b-col(md="12")
            h5.mb-1
              | {{ $t('label.actionPlans') }}
        
        b-row(v-if="!readOnly")
          // Action plan type
          b-col(md="4")
            b-form-group(:label="$t('label.actionPlanType')", :label-for="$t('label.actionPlanType')")
              validation-provider(:name="$t('label.actionPlanType')", v-slot="{ errors }")
                v-select(
                  v-model="actionPlanType"
                  label="title"
                  :options="actionPlanOptions"
                  :reduce="(state) => state.value"
                  :disabled="readOnly || stages[data.stage] > 3 && allActionPlansBeyondAnalysis"
                  :placeholder="$t('placeholder.actionPlanType')"
                )
                small(class="text-danger") {{ errors[0] }}

          // Add action plan
          b-col(md="4")
            b-form-group(:label="$t('label.actionPlan')", :label-for="$t('label.actionPlan')")
              b-button(
                type="button"
                variant="success"
                @click="addActionPlan('analysis')"
                :disabled="!pacEnabled || stages[data.stage] > 3 && allActionPlansBeyondAnalysis"
              )
                | {{ $t('message.addActionPlan') }}
              div(v-show="!pacEnabled && (stages[data.stage] <= 3 || !allActionPlansBeyondAnalysis)")
                small(class="text-danger") {{ actionPlanType && fiveWhyMethodEnabled ? $t('message.5WhysMustBeComplete') : $t('message.youMustSelectActionPlanType') }}
        
        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!analysisActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-for="(item, index) in analysisActionPlans" :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'analysis' ? 'border-warning' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              validation-provider(:name="`${$t('label.actionPlanName')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(v-model="item.name", label="title", :options="actionPlanNames", :reduce="(name) => name.value", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.name')", taggable, push-tags, :create-option="name => ({ title: name, value: name })")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.Type')", :label-for="$t('label.Type')")
              validation-provider(:name="`${$t('label.Type')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(v-model="item.type", label="title", :options="actionPlanOptions", :reduce="(state) => state.value", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.actionPlanType')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              validation-provider(:name="`${$t('label.action_plan_responsible')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(
                  v-model="item.executionResponsible"
                  label="title"
                  :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  :options="workersTotal"
                  :selectable="worker => !worker.deleted"
                  :reduce="worker => worker.value"
                  :placeholder="$t('placeholder.action_plan_responsible')"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(md="2")
            b-form-group(:label="$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)", label-for="startDate")
              validation-provider(:name="`${$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)} ${index + 1}`", rules="required", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.startDate"
                  :config="item.startDateConfig"
                  :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(v-if="item.type === 'in_term'", md="2")
            b-form-group(:label="$t('label.endDate')", :label-for="$t('label.endDate')")
              validation-provider(:name="`${$t('label.endDate')} ${index + 1}`", rules="required", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.endDate"
                  :config="(readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')) ? flatPickrConfig : item.endDateConfig"
                  :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(v-if="item.type === 'immediate'", :md="item.evidence_key && item.evidence_key.length && !readOnly ? '2' : readOnly ? '6' : '4'")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key)"
              )
                | {{ $t('message.open') }}

              // Upload Document
              b-button(
                v-else
                class="mr-1"
                type="button"
                variant="info"
                :disabled="readOnly"
                @click="activateEvidenceSelector(index, 'analysis')"
              )
                | {{ $t('message.upload') }}
              small(v-if="item.evidenceFile && item.evidenceFile.length")
                | {{ item.evidenceFile.length === 1 ? item.evidenceFile[0].name : `${item.evidenceFile.length} ${$t('evidences')}` }}
              small(v-else-if="!(item.evidence_key && item.evidence_key.length) && !readOnly", class="text-danger")
                | {{ $t('message.upload_evidence_required') }}

          input(
            type="file"
            ref="evidenceSelectorAnalysis"
            style="display: none"
            :accept="inputFileTypes"
            multiple
            @change="changeEvidenceSelected"
          )

          b-col(v-if="!readOnly" md="2" class="mt-2")
            b-button(
              class="mr-1"
              type="button"
              variant="danger"
              :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
              v-b-modal="`modal ${item._id || index}`"
            )
              | {{ $t('message.delete') }}

            b-modal(
              :id="`modal ${item._id || index}`"
              centered
              no-close-on-backdrop
              modal-class="modal-danger"
              ok-variant="danger"
              cancel-variant="outline-secondary"
              :title="$t('message.confirm_action')"
              :ok-title="$t('message.delete')"
              :cancel-title="$t('message.cancel')"
              @ok="deleteActionPlan(item._id, index)"
            )
              | {{ $t('message.confirm_delete_action_plan') }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" @change="(checked) => handleCheck(checked, index, 'analysis')" :disabled="readOnly || !!item._id && (item.stage !== 'analysis' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < analysisActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.analysisTab", tab="analysisTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Approval
    div(v-if="readOnly || stages[data.stage] >= 4", :title="$t('message.approval')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.approval') }}
      validation-observer(ref="approvalTab", tag="form")
        // Total approval title
        b-row
          b-col(md="6")
            h5.mb-1
              | {{ $t('label.globalApproval') }}

        // Approve all action plans
        b-row
          b-col(v-if="!readOnly" :md="approveAllCommentEnabled ? '4' : '12'")
            b-form-group(:label="$t('label.approveAllActionPlans')", :label-for="$t('label.approveAllActionPlans')")
              b-button(
                type="button"
                variant="success"
                @click="approveAllActionPlans"
                :disabled="readOnly || !approveAllEnabled || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'"
              )
                | {{ $t('message.approveAll') }}
              //- small(v-if="!approveAllEnabled && data.stage === 'approval' && (userData.worker_id.$oid === data.approvalResponsible || role === 'consultant')", class="text-danger ml-1") {{ $t('message.mustSeeAllEvidences') }}
          b-col(v-if="approveAllCommentEnabled", :md="readOnly ? '12' : '8'")
            b-form-group(:label="$t('label.approvalComment')", :label-for="$t('label.approvalComment')")
              validation-provider(:name="$t('label.approvalComment')", :rules="data.stage === 'approval' && !readOnly ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="data.approvalComment", :disabled="readOnly || stages[data.stage] > 4", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ data.approvalComment }}
                small(class="text-danger") {{ errors[0] }}

        // Problem
        b-row.mt-1
          b-col(md="6")
            h5
              | {{ $t('label.Problem') }}
        b-row
          b-col(md="12")
            b-form-group
              small.text-muted
                | {{ $t('message.complaint_analysis') }}
              //- b-form-textarea(
              //-   v-model="data.problemStatement"
              //-   :disabled="true"
              //-   :placeholder="$t('message.describe_complaint_analysis')"
              //- )
              div(class="print-text")
                | {{ data.problemStatement }}

        // 5 Why Methodology
        b-row.mt-1
          b-col(md="12")
            b-form-group(label="" label-for="5WhyMethodology")
              b-form-checkbox(
                id="checkbox-1"
                v-model="fiveWhyMethodEnabled"
                name="checkbox-1"
                :value="true"
                :unchecked-value="false"
              )
                span.font-weight-bold {{ $t('label.WhyMethod') }}
        
        // 5 whys
        b-row(v-if="fiveWhyMethodEnabled")
          b-col(md="4")
            b-form-group(:label="$t('label.Why1')", :label-for="$t('label.Why1')")
              //- b-form-textarea(v-model="data.why1", :disabled="true", :placeholder="$t('placeholder.first_cause')")
              div(class="print-text")
                | {{ data.why1 }}
              b-form-checkbox(v-model="data.rootCause" :value="1" :unchecked-value="100" class="custom-mt" :disabled="true")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why2')", :label-for="$t('label.Why2')")
              //- b-form-textarea(v-model="data.why2", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why2 }}
              b-form-checkbox(v-model="data.rootCause" :value="2" :unchecked-value="100" class="custom-mt" :disabled="true")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why3')", :label-for="$t('label.Why3')")
              //- b-form-textarea(v-model="data.why3", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why3 }}
              b-form-checkbox(v-model="data.rootCause" :value="3" :unchecked-value="100" class="custom-mt" :disabled="true")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why4')", :label-for="$t('label.Why4')")
              //- b-form-textarea(v-model="data.why4", :disabled="true", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why4 }}
              b-form-checkbox(v-model="data.rootCause" :value="4" :unchecked-value="100" class="custom-mt" :disabled="true")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why5')", :label-for="$t('label.Why5')")
              //- b-form-textarea(v-model="data.why5", :disabled="true", :placeholder="$t('placeholder.root_cause')")
              div(class="print-text")
                | {{ data.why5 }}
              b-form-checkbox(v-model="data.rootCause" :value="5" :unchecked-value="100" class="custom-mt" :disabled="true")
                small
                  | {{ $t('label.rootCause') }}

        // Title
        b-row(class="mt-1")
          b-col(md="12")
            h5(class="mb-0")
              | {{ $t('label.actionPlans') }}
        
        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!analysisActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-for="(item, index) in analysisActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'approval' ? 'border-warning' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              v-select(v-model="item.name", label="title", :options="actionPlanNames", :reduce="(name) => name.value", :disabled="true", :placeholder="$t('placeholder.name')")

          b-col(md="3")
            b-form-group(:label="$t('label.Type')", :label-for="$t('label.Type')")
              v-select(v-model="item.type", label="title", :options="actionPlanOptions", :reduce="(state) => state.value", :disabled="true", :placeholder="$t('placeholder.actionPlanType')")
          
          b-col(md="4")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="6")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              v-select(
                v-model="item.executionResponsible"
                label="title"
                :disabled="true"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :placeholder="$t('placeholder.action_plan_responsible')"
              )

          b-col(md="3")
            b-form-group(:label="$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)", label-for="startDate")
              flat-pickr(
                v-model="item.startDate"
                :config="flatPickrConfig"
                :disabled="true"
                class="form-control"
              )
            
          b-col(v-if="item.type === 'in_term'", md="3")
            b-form-group(:label="$t('label.endDate')", :label-for="$t('label.endDate')")
              flat-pickr(
                v-model="item.endDate"
                :config="flatPickrConfig"
                :disabled="true"
                class="form-control"
              )
          
          b-col(v-else, md="3")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key); addEvidenceSeen(item._id, 'approval')"
              )
                | {{ $t('message.open') }}
        
          b-col(md="3")
            b-form-group(:label="$t('message.approval')", :label-for="$t('message.approval')")
              validation-provider(:name="`${$t('message.approval')} ${index + 1}`", :rules="item.stage === 'approval' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.approvalResult", :disabled="readOnly || item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", label="title", :options="resultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
              validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'approval' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.approvalNextStage", :disabled="readOnly || item.approvalResult !== 'rejected' || item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", label="title", :options="item.type === 'immediate' ? correctiveStageOptions : inTermApprovalStageComplaintOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="6")
            b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
              validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'approval' && !approveAllCommentEnabled ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="item.approvalComment", :disabled="readOnly || item.stage !== 'approval' || userData.worker_id.$oid !== data.approvalResponsible && role !== 'consultant'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ item.approvalComment }}
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" :disabled="true")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < analysisActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.approvalTab", tab="approvalTab", :userType="userType", :clientId="clientId", @add-message="addMessage")
    
    // Corrective
    div(v-if="readOnly || stages[data.stage] >= 5", :title="$t('complaintStages.corrective')")
      h4.mt-1.mb-2.print-title
        | {{ $t('complaintStages.corrective') }}
      validation-observer(ref="correctiveTab", tag="form")
        // Title
        b-row
          b-col(md="12")
            h5.mb-1
              | {{ readOnly ? $t('message.action_plans_being_executed') : $t('label.inTermActionPlans') }}

        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!analysisActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-if="item.type === 'in_term' && (item.executionResponsible === userData.worker_id.$oid || data.verificationResponsible && data.verificationResponsible.includes(userData.worker_id.$oid) || role === 'consultant')", v-for="(item, index) in analysisActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'corrective' ? 'border-warning' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              v-select(v-model="item.name", label="title", :options="actionPlanNames", :reduce="(name) => name.value", :disabled="true", :placeholder="$t('placeholder.name')")

          b-col(md="3")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              v-select(
                v-model="item.executionResponsible"
                label="title"
                :disabled="true"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :placeholder="$t('placeholder.action_plan_responsible')"
              )

          b-col(md="2")
            b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
              validation-provider(:name="`${$t('label.executionDate')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.executionDate"
                  :config="flatPickrConfig"
                  :disabled="readOnly || item.stage !== 'corrective'"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}
          
          b-col(md="3")
            b-form-group(:label="$t('label.result')", :label-for="$t('label.result')")
              validation-provider(:name="`${$t('label.result')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.correctiveResult", :disabled="readOnly || item.stage !== 'corrective'", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
              validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.correctiveNextStage", :disabled="readOnly || item.correctiveResult !== 'rejected' || item.stage !== 'corrective'", label="title", :options="correctiveStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key)"
              )
                | {{ $t('message.open') }}

              // Upload Document
              b-button(
                v-else
                class="mr-1"
                type="button"
                variant="info"
                :disabled="readOnly || item.stage !== 'corrective'"
                @click="activateEvidenceSelector(index, 'analysis')"
              )
                | {{ $t('message.upload') }}
              small(v-if="item.evidenceFile && item.evidenceFile.length")
                | {{ item.evidenceFile.length === 1 ? item.evidenceFile[0].name : `${item.evidenceFile.length} ${$t('evidences')}` }}
              small(v-else-if="!(item.evidence_key && item.evidence_key.length) && !readOnly && item.stage === 'corrective' && item.correctiveNextStage === 'verification'", class="text-danger")
                | {{ $t('message.upload_evidence_required') }}

          b-col(md="12")
            b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
              validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'corrective' ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="item.correctiveComment", :disabled="readOnly || item.stage !== 'corrective'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ item.correctiveComment }}
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" :disabled="true")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < analysisActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.correctiveTab", tab="correctiveTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Verification
    div(v-if="readOnly || stages[data.stage] >= 6 || analysisActionPlans.some(e => e.stage === 'verification')", :title="$t('message.verification')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.verification') }}
      validation-observer(ref="verificationTab", tag="form")
        // Total verification title
        b-row
          b-col(md="6")
            h5.mb-1
              | {{ $t('label.globalVerification') }}

        // Verify all action plans
        b-row
          b-col(v-if="!readOnly" :md="verifyAllCommentEnabled ? '4' : '12'")
            b-form-group(:label="$t('label.verifyAllActionPlans')", :label-for="$t('label.verifyAllActionPlans')")
              b-button(
                type="button"
                variant="success"
                @click="verifyAllActionPlans"
                :disabled="readOnly || !verifyAllEnabled || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'"
              )
                | {{ $t('message.verifyAll') }}
              //- small(v-if="!verifyAllEnabled && data.stage === 'verification' && (data.verificationResponsible && data.verificationResponsible.includes(userData.worker_id.$oid) || role === 'consultant')", class="text-danger ml-1") {{ $t('message.mustSeeAllEvidences') }}
          b-col(v-if="verifyAllCommentEnabled", :md="readOnly ? '12' : '8'")
            b-form-group(:label="$t('label.verificationComment')", :label-for="$t('label.verificationComment')")
              validation-provider(:name="$t('label.verificationComment')", :rules="data.stage === 'verification' && !readOnly ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="data.verificationComment", :disabled="readOnly || stages[data.stage] > 6", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ data.verificationComment }}
                small(class="text-danger") {{ errors[0] }}
        
        // Title
        b-row(class="mt-1")
          b-col(md="12")
            h5(class="mb-0")
              | {{ $t('label.actionPlans') }}

        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!analysisActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-for="(item, index) in analysisActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'verification' ? 'border-warning' : item.stage === 'end' ? 'border-success' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              v-select(v-model="item.name", label="title", :options="actionPlanNames", :reduce="(name) => name.value", :disabled="true", :placeholder="$t('placeholder.name')")

          b-col(md="3")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              v-select(
                v-model="item.executionResponsible"
                label="title"
                :disabled="true"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :placeholder="$t('placeholder.action_plan_responsible')"
              )

          b-col(md="2")
            b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
              flat-pickr(
                v-model="item.executionDate"
                :config="flatPickrConfig"
                :disabled="true"
                class="form-control"
              )
          
          b-col(:md="item.type === 'in_term' ? '2' : '10'")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key); addEvidenceSeen(item._id, 'verification')"
              )
                | {{ $t('message.open') }}
          
          b-col(v-if="item.type === 'in_term'", md="3")
            b-form-group(:label="$t('label.investigationResult')", :label-for="$t('label.investigationResult')")
              v-select(v-model="item.correctiveResult", :disabled="true", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")

          b-col(v-if="item.type === 'in_term'", md="5")
            b-form-group(:label="$t('label.investigationComment')", :label-for="$t('label.investigationComment')")
              //- b-form-textarea(v-model="item.correctiveComment", :disabled="true", :placeholder="$t('placeholder.comment')")
              div(class="print-text")
                | {{ item.correctiveComment }}

          b-col(md="3")
            b-form-group(:label="$t('message.verification')", :label-for="$t('message.verification')")
              validation-provider(:name="`${$t('message.verification')} ${index + 1}`", :rules="item.stage === 'verification' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.verificationResult", :disabled="readOnly || item.stage !== 'verification' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", label="title", :options="resultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
              validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'verification' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.verificationNextStage", :disabled="readOnly || item.verificationResult !== 'rejected' || item.stage !== 'verification' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", label="title", :options="item.type === 'immediate' ? immediateVerificationStageOptions : inTermVerificationStageComplaintOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="6")
            b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
              validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'verification' && !verifyAllCommentEnabled ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="item.verificationComment", :disabled="readOnly || item.stage !== 'verification' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ item.verificationComment }}
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" :disabled="true")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < analysisActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.verificationTab", tab="verificationTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Corrective Measures
    div(v-if="data.type === 'karinLaw' && (readOnly || stages[data.stage] >= 7)", :title="$t('message.correctiveMeasures')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.correctiveMeasures') }}
      validation-observer(ref="correctiveMeasuresTab", tag="form")
        // Report Conclusion
        b-row
          b-col(md="6")
            h5
              | {{ $t('label.reportConclusion') }}
        b-row
          b-col(md="12")
            b-form-group
              //- b-form-textarea(v-model="data.reportConclusion", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures", :placeholder="$t('message.describe_report_conclusion')")
              div(class="print-text")
                | {{ data.reportConclusion }}

        // 5 Why Methodology
        b-row.mt-1
          b-col(md="12")
            b-form-group(label="" label-for="5WhyMethodology")
              b-form-checkbox(id="checkbox-1", v-model="fiveWhyMethodCorrectiveMeasuresEnabled", name="checkbox-1", :value="true", :unchecked-value="false")
                span.font-weight-bold {{ $t('label.WhyMethod') }}
        
        // 5 whys
        b-row(v-if="fiveWhyMethodCorrectiveMeasuresEnabled")
          b-col(md="4")
            b-form-group(:label="$t('label.Why1')", :label-for="$t('label.Why1')")
              //- b-form-textarea(v-model="data.why6", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures", :placeholder="$t('placeholder.first_cause')")
              div(class="print-text")
                | {{ data.why6 }}
              b-form-checkbox(v-model="data.rootCauseCorrectiveMeasures" :value="6" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why2')", :label-for="$t('label.Why2')")
              //- b-form-textarea(v-model="data.why7", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures || data.rootCauseCorrectiveMeasures < 7", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why7 }}
              b-form-checkbox(v-model="data.rootCauseCorrectiveMeasures" :value="7" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why3')", :label-for="$t('label.Why3')")
              //- b-form-textarea(v-model="data.why8", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures || data.rootCauseCorrectiveMeasures < 8", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why8 }}
              b-form-checkbox(v-model="data.rootCauseCorrectiveMeasures" :value="8" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why4')", :label-for="$t('label.Why4')")
              //- b-form-textarea(v-model="data.why9", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures || data.rootCauseCorrectiveMeasures < 9", :placeholder="$t('placeholder.inner_cause')")
              div(class="print-text")
                | {{ data.why9 }}
              b-form-checkbox(v-model="data.rootCauseCorrectiveMeasures" :value="9" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures")
                small
                  | {{ $t('label.rootCause') }}
          b-col(md="4")
            b-form-group(:label="$t('label.Why5')", :label-for="$t('label.Why5')")
              //- b-form-textarea(v-model="data.why10", :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures || data.rootCauseCorrectiveMeasures < 10", :placeholder="$t('placeholder.root_cause')")
              div(class="print-text")
                | {{ data.why10 }}
              b-form-checkbox(v-model="data.rootCauseCorrectiveMeasures" :value="10" :unchecked-value="100" class="custom-mt" :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures")
                small
                  | {{ $t('label.rootCause') }}
        
        // Action Plans Title
        b-row(class="mt-1")
          b-col(md="12")
            h5.mb-1
              | {{ $t('label.actionPlans') }}

        b-row(v-if="!readOnly")
          // Action plan type
          b-col(md="4")
            b-form-group(:label="$t('label.actionPlanType')", :label-for="$t('label.actionPlanType')")
              validation-provider(:name="$t('label.actionPlanType')", v-slot="{ errors }")
                v-select(
                  v-model="actionPlanTypeCorrectiveMeasures"
                  label="title"
                  :options="actionPlanOptions"
                  :reduce="(state) => state.value"
                  :disabled="readOnly || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures"
                  :placeholder="$t('placeholder.actionPlanType')"
                )
                small(class="text-danger") {{ errors[0] }}

          // Add action plan
          b-col(md="4")
            b-form-group(:label="$t('label.actionPlan')", :label-for="$t('label.actionPlan')")
              b-button(
                type="button"
                variant="success"
                @click="addActionPlan('correctiveMeasures')"
                :disabled="!pacEnabledCorrectiveMeasures || stages[data.stage] > 7 && allActionPlansBeyondCorrectiveMeasures"
              )
                | {{ $t('message.addActionPlan') }}
              div(v-show="!pacEnabledCorrectiveMeasures && (stages[data.stage] <= 7 || !allActionPlansBeyondCorrectiveMeasures)")
                small(class="text-danger") {{ actionPlanTypeCorrectiveMeasures && fiveWhyMethodCorrectiveMeasuresEnabled ? $t('message.5WhysMustBeComplete') : $t('message.youMustSelectActionPlanType') }}
        
        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!correctiveMeasuresActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-for="(item, index) in correctiveMeasuresActionPlans" :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'correctiveMeasures' ? 'border-warning' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              validation-provider(:name="`${$t('label.actionPlanName')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(v-model="item.name", label="title", :options="actionPlanNamesCorrectiveMeasures", :reduce="(name) => name.value", :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.name')", taggable, push-tags, :create-option="name => ({ title: name, value: name })")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.Type')", :label-for="$t('label.Type')")
              validation-provider(:name="`${$t('label.Type')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(v-model="item.type", label="title", :options="actionPlanOptions", :reduce="(state) => state.value", :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.actionPlanType')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              validation-provider(:name="`${$t('label.action_plan_responsible')} ${index + 1}`", rules="required", v-slot="{ errors }")
                v-select(
                  v-model="item.executionResponsible"
                  label="title"
                  :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  :options="workersTotal"
                  :selectable="worker => !worker.deleted"
                  :reduce="worker => worker.value"
                  :placeholder="$t('placeholder.action_plan_responsible')"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(md="2")
            b-form-group(:label="$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)", label-for="startDate")
              validation-provider(:name="`${$t(`label.${item.type === 'immediate' ? 'executionDate' : 'startDate'}`)} ${index + 1}`", rules="required", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.startDate"
                  :config="item.startDateConfig"
                  :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(v-if="item.type === 'in_term'", md="2")
            b-form-group(:label="$t('label.endDate')", :label-for="$t('label.endDate')")
              validation-provider(:name="`${$t('label.endDate')} ${index + 1}`", rules="required", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.endDate"
                  :config="(readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')) ? flatPickrConfig : item.endDateConfig"
                  :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}

          b-col(v-if="item.type === 'immediate'", :md="item.evidence_key && item.evidence_key.length && !readOnly ? '2' : readOnly ? '6' : '4'")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key)"
              )
                | {{ $t('message.open') }}

              // Upload Document
              b-button(
                v-else
                class="mr-1"
                type="button"
                variant="info"
                :disabled="readOnly"
                @click="activateEvidenceSelector(index, 'correctiveMeasures')"
              )
                | {{ $t('message.upload') }}
              small(v-if="item.evidenceFile && item.evidenceFile.length")
                | {{ item.evidenceFile.length === 1 ? item.evidenceFile[0].name : `${item.evidenceFile.length} ${$t('evidences')}` }}
              small(v-else-if="!(item.evidence_key && item.evidence_key.length) && !readOnly", class="text-danger")
                | {{ $t('message.upload_evidence_required') }}

          input(
            type="file"
            ref="evidenceSelectorCorrectiveMeasures"
            style="display: none"
            :accept="inputFileTypes"
            multiple
            @change="changeEvidenceSelected"
          )

          b-col(v-if="!readOnly" md="2" class="mt-2")
            b-button(
              class="mr-1"
              type="button"
              variant="danger"
              :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')"
              v-b-modal="`modal ${item._id || index}`"
            )
              | {{ $t('message.delete') }}

            b-modal(
              :id="`modal ${item._id || index}`"
              centered
              no-close-on-backdrop
              modal-class="modal-danger"
              ok-variant="danger"
              cancel-variant="outline-secondary"
              :title="$t('message.confirm_action')"
              :ok-title="$t('message.delete')"
              :cancel-title="$t('message.cancel')"
              @ok="deleteActionPlan(item._id, index)"
            )
              | {{ $t('message.confirm_delete_action_plan') }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" @change="(checked) => handleCheck(checked, index, 'correctiveMeasures')" :disabled="readOnly || !!item._id && (item.stage !== 'correctiveMeasures' || userData.worker_id.$oid !== data.proposalResponsible && role !== 'consultant')")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < correctiveMeasuresActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.correctiveMeasuresTab", tab="correctiveMeasuresTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Implementation
    div(v-if="data.type === 'karinLaw' && (readOnly || stages[data.stage] >= 8)", :title="$t('message.implementation')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.implementation') }}
      validation-observer(ref="implementationTab", tag="form")
        // Title
        b-row
          b-col(md="12")
            h5.mb-1
              | {{ readOnly ? $t('message.action_plans_being_executed') : $t('label.inTermActionPlans') }}

        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!correctiveMeasuresActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-if="item.type === 'in_term' && (item.executionResponsible === userData.worker_id.$oid || data.verificationResponsible && data.verificationResponsible.includes(userData.worker_id.$oid) || role === 'consultant')", v-for="(item, index) in correctiveMeasuresActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'implementation' ? 'border-warning' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              v-select(v-model="item.name", label="title", :options="actionPlanNamesCorrectiveMeasures", :reduce="(name) => name.value", :disabled="true", :placeholder="$t('placeholder.name')")

          b-col(md="3")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              v-select(
                v-model="item.executionResponsible"
                label="title"
                :disabled="true"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :placeholder="$t('placeholder.action_plan_responsible')"
              )

          b-col(md="2")
            b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
              validation-provider(:name="`${$t('label.executionDate')} ${index + 1}`", :rules="item.stage === 'implementation' ? 'required' : ''", v-slot="{ errors }")
                flat-pickr(
                  v-model="item.executionDate"
                  :config="flatPickrConfig"
                  :disabled="readOnly || item.stage !== 'implementation'"
                  class="form-control"
                )
                small(class="text-danger") {{ errors[0] }}
          
          b-col(md="3")
            b-form-group(:label="$t('label.result')", :label-for="$t('label.result')")
              validation-provider(:name="`${$t('label.result')} ${index + 1}`", :rules="item.stage === 'implementation' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.implementationResult", :disabled="readOnly || item.stage !== 'implementation'", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
              validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'implementation' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.implementationNextStage", :disabled="readOnly || item.implementationResult !== 'rejected' || item.stage !== 'implementation'", label="title", :options="implementationStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key)"
              )
                | {{ $t('message.open') }}

              // Upload Document
              b-button(
                v-else
                class="mr-1"
                type="button"
                variant="info"
                :disabled="readOnly || item.stage !== 'implementation'"
                @click="activateEvidenceSelector(index, 'correctiveMeasures')"
              )
                | {{ $t('message.upload') }}
              small(v-if="item.evidenceFile && item.evidenceFile.length")
                | {{ item.evidenceFile.length === 1 ? item.evidenceFile[0].name : `${item.evidenceFile.length} ${$t('evidences')}` }}
              small(v-else-if="!(item.evidence_key && item.evidence_key.length) && !readOnly && item.stage === 'implementation' && item.implementationNextStage === 'finalized'", class="text-danger")
                | {{ $t('message.upload_evidence_required') }}

          b-col(md="12")
            b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
              validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'implementation' ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="item.implementationComment", :disabled="readOnly || item.stage !== 'implementation'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ item.implementationComment }}
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" :disabled="true")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < correctiveMeasuresActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.correctiveTab", tab="implementationTab", :userType="userType", :clientId="clientId", @add-message="addMessage")

    // Finalized
    div(v-if="data.type === 'karinLaw' && (readOnly || stages[data.stage] >= 9)", :title="$t('message.finalized')")
      h4.mt-1.mb-2.print-title
        | {{ $t('message.finalized') }}
      validation-observer(ref="finalizedTab", tag="form")
        // Total finalization title
        b-row
          b-col(md="6")
            h5.mb-1
              | {{ $t('label.globalFinalization') }}

        // Finalize all action plans
        b-row
          b-col(v-if="!readOnly" :md="finalizeAllCommentEnabled ? '4' : '12'")
            b-form-group(:label="$t('label.finalizeAllActionPlans')", :label-for="$t('label.finalizeAllActionPlans')")
              b-button(
                type="button"
                variant="success"
                @click="finalizeAllActionPlans"
                :disabled="readOnly || !finalizeAllEnabled || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'"
              )
                | {{ $t('message.finalizeAll') }}
              //- small(v-if="!finalizeAllEnabled && data.stage === 'finalized' && (data.verificationResponsible && data.verificationResponsible.includes(userData.worker_id.$oid) || role === 'consultant')", class="text-danger ml-1") {{ $t('message.mustSeeAllEvidences') }}
          b-col(v-if="finalizeAllCommentEnabled", :md="readOnly ? '12' : '8'")
            b-form-group(:label="$t('label.finalizedComment')", :label-for="$t('label.finalizedComment')")
              validation-provider(:name="$t('label.finalizedComment')", :rules="data.stage === 'finalized' && !readOnly ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="data.finalizedComment", :disabled="readOnly || data.stage === 'end'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ data.finalizedComment }}
                small(class="text-danger") {{ errors[0] }}
        
        // Title
        b-row(class="mt-1")
          b-col(md="12")
            h5(class="mb-0")
              | {{ $t('label.actionPlans') }}

        // No action plans message
        ul.list-group.mt-1.mb-2(v-if="!correctiveMeasuresActionPlans.length")
          li(class="list-group-item text-center text-muted font-weight-bold bg-light")
            | {{ $t('message.no_action_plans') }}

        // Action plans list
        b-row(v-for="(item, index) in correctiveMeasuresActionPlans", :key="index" :class="`rounded ${index % 2 === 0 ? '' : 'bg-light py-1'} ${item.isRootCause ? 'border-primary' : ''} ${item.stage === 'finalized' ? 'border-warning' : item.stage === 'end' ? 'border-success' : ''}`")
          b-col(v-if="index % 2 === 0", md="12")
            hr(:class="index ? 'my-2' : 'mb-2'")

          b-col(md="5")
            b-form-group(:label="$t('label.actionPlanName')", :label-for="$t('label.actionPlanName')")
              v-select(v-model="item.name", label="title", :options="actionPlanNamesCorrectiveMeasures", :reduce="(name) => name.value", :disabled="true", :placeholder="$t('placeholder.name')")

          b-col(md="3")
            b-form-group(:label="$t('label.description')", :label-for="$t('label.description')")
              //- b-form-textarea(v-model="item.description", :disabled="true", :placeholder="$t('placeholder.action_plan_description')")
              div(class="print-text")
                | {{ item.description }}

          b-col(md="4")
            b-form-group(:label="$t('label.action_plan_responsible')", :label-for="$t('label.action_plan_responsible')")
              v-select(
                v-model="item.executionResponsible"
                label="title"
                :disabled="true"
                :options="workersTotal"
                :selectable="worker => !worker.deleted"
                :reduce="worker => worker.value"
                :placeholder="$t('placeholder.action_plan_responsible')"
              )

          b-col(md="2")
            b-form-group(:label="$t('label.executionDate')", label-for="executionDate")
              flat-pickr(
                v-model="item.executionDate"
                :config="flatPickrConfig"
                :disabled="true"
                class="form-control"
              )
          
          b-col(:md="item.type === 'in_term' ? '2' : '10'")
            b-form-group(:label="$t('label.evidence')", :label-for="$t('label.evidence')")
              // Evidence key message
              span(v-if="readOnly")
                | {{ formatKey(item.evidence_key) }}
              
              // Open Document
              b-button(
                v-else-if="item.evidence_key && item.evidence_key.length"
                class="mr-1"
                type="button"
                variant="success"
                :disabled="readOnly"
                @click="openDocument(item.evidence_key); addEvidenceSeen(item._id, 'finalized')"
              )
                | {{ $t('message.open') }}
          
          b-col(v-if="item.type === 'in_term'", md="3")
            b-form-group(:label="$t('label.implementationResult')", :label-for="$t('label.implementationResult')")
              v-select(v-model="item.implementationResult", :disabled="true", label="title", :options="correctiveResultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")

          b-col(v-if="item.type === 'in_term'", md="5")
            b-form-group(:label="$t('label.implementationComment')", :label-for="$t('label.implementationComment')")
              //- b-form-textarea(v-model="item.implementationComment", :disabled="true", :placeholder="$t('placeholder.comment')")
              div(class="print-text")
                | {{ item.implementationComment }}

          b-col(md="3")
            b-form-group(:label="$t('message.finalized')", :label-for="$t('message.finalized')")
              validation-provider(:name="`${$t('message.finalized')} ${index + 1}`", :rules="item.stage === 'finalized' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.finalizedResult", :disabled="readOnly || item.stage !== 'finalized' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", label="title", :options="resultOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.result')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="3")
            b-form-group(:label="$t('label.nextStage')", :label-for="$t('label.nextStage')")
              validation-provider(:name="`${$t('label.nextStage')} ${index + 1}`", :rules="item.stage === 'finalized' ? 'required' : ''", v-slot="{ errors }")
                v-select(v-model="item.finalizedNextStage", :disabled="readOnly || item.finalizedResult !== 'rejected' || item.stage !== 'finalized' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", label="title", :options="item.type === 'immediate' ? immediateFinalizedStageOptions : inTermFinalizedStageOptions", :reduce="(state) => state.value", :placeholder="$t('placeholder.nextStage')")
                small(class="text-danger") {{ errors[0] }}

          b-col(md="6")
            b-form-group(:label="$t('label.comment')", :label-for="$t('label.comment')")
              validation-provider(:name="`${$t('label.comment')} ${index + 1}`", :rules="item.stage === 'finalized' && !finalizeAllCommentEnabled ? 'required' : ''", v-slot="{ errors }")
                //- b-form-textarea(v-model="item.finalizedComment", :disabled="readOnly || item.stage !== 'finalized' || (!data.verificationResponsible || !data.verificationResponsible.includes(userData.worker_id.$oid)) && role !== 'consultant'", :placeholder="$t('placeholder.comment')")
                div(class="print-text")
                  | {{ item.finalizedComment }}
                small(class="text-danger") {{ errors[0] }}

          b-col(md="4")
            b-form-checkbox(v-model="item.isRootCause" :disabled="true")
              small
                | {{ $t('label.rootCause') }}

          b-col.ml-auto.text-right(v-if="item.lastModifiedBy")
            small
              | {{ $t('message.lastModifiedBy') }} {{ item.lastModifiedBy.name }} {{ $t('message.on') }} {{ item.lastModifiedDate }}

          b-col(v-if="index % 2 === 0 && index < correctiveMeasuresActionPlans.length - 1", md="12")
            hr(class="mb-2")

        hr(class="mb-2")

        // Messages
        messages(:messages="tabMessages.finalizedTab", tab="finalizedTab", :userType="userType", :clientId="clientId", @add-message="addMessage")
</template>

<script>
import vSelect from 'vue-select'
import { onMounted, ref, computed, watch } from '@vue/composition-api/dist/vue-composition-api'
// import useCommon from '@/views/organization/useCommon'
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { required } from "@validations"
import i18n from '@/libs/i18n'
import flatPickr from 'vue-flatpickr-component'
import { useRouter } from '@core/utils/utils'
import { stateOptions, actionPlanOptions, resultOptions, correctiveResultOptions, inTermApprovalStageComplaintOptions, correctiveStageOptions, immediateVerificationStageOptions, inTermVerificationStageComplaintOptions, implementationStageOptions, immediateFinalizedStageOptions, inTermFinalizedStageOptions, flatPickrConfig, inputFileTypes, actionPlanNames, actionPlanNamesCorrectiveMeasures } from '@/constants'
import { FormWizard, TabContent } from "vue-form-wizard"
import "vue-form-wizard/dist/vue-form-wizard.min.css"
import { BFormDatepicker, BFormCheckbox, BModal, VBModal } from "bootstrap-vue"
// import awsConnection from '@/views/habit/aws'
import Messages from './PrintableMessages.vue'
// import useCommonTodo from '@/views/apps/todo/useCommonTodo'
import store from '@/store'
import { useLambda } from '@/views/habit/awsLambda'
import InformationButton from '@/views/components/Shared/Buttons/InformationButton.vue'
import { oid, date } from '@/helpers/mongoHelpers'

export default {
  name: 'ComplaintPrintableForm',
  components: {
    vSelect,
    ValidationObserver,
    ValidationProvider,
    flatPickr,
    FormWizard,
    TabContent,
    BFormDatepicker,
    BFormCheckbox,
    Messages,
    BModal,
    InformationButton,
  },
  directives: {
    'b-modal': VBModal,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
    updateActiveTab: {
      type: Boolean,
      default: false,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
    userType: {
      type: String,
      default: 'manager',
    },
    clientId: {
      type: String,
      default: '',
    }
  },
  setup(props, { emit }) {
    // const { getWorkersTotalForDropDown, workersTotal, getImprovementsForDropDown, improvements, getLocationsForDropDown, locations, openDocument, formatDate, formatDateAsYMD, createActionPlanEvent, updateActionPlanEvent } = useCommon()
    const workersTotal = []
    const improvements = []
    const locations = []
    const companies = []
    const openDocument = () => {}
    const formatDateAsYMD = () => {}
    const createActionPlanEvent = () => {}
    const updateActionPlanEvent = () => {}

    const { router } = useRouter()
    // const { singleUpload } = awsConnection()
    const { createItem, updateItem } = useLambda()
    // const { sendEmailActionPlan } = useCommonTodo()
    const { role } = store.state?.userStore?.userData
    const form = ref(null)
    const evidenceSelectorAnalysis = ref(null)
    const evidenceSelectorCorrectiveMeasures = ref(null)
    const evidenceIndex = ref(null)
    const noDocumentMessage = computed(() => i18n.t('message.no_document_attached'))
    const identificationTab = ref(null)
    const responsiblesTab = ref(null)
    const analysisTab = ref(null)
    const approvalTab = ref(null)
    const correctiveTab = ref(null)
    const verificationTab = ref(null)
    const correctiveMeasuresTab = ref(null)
    const implementationTab = ref(null)
    const finalizedTab = ref(null)
    const actionPlanType = ref(null)
    const actionPlanTypeCorrectiveMeasures = ref(null)
    const fiveWhyMethodEnabled = ref(false)
    const fiveWhyMethodCorrectiveMeasuresEnabled = ref(false)
    const pacEnabled = computed(() => actionPlanType.value && (!fiveWhyMethodEnabled.value || props.data.why1 && (props.data.why2 || props.data.rootCause < 2) && (props.data.why3 || props.data.rootCause < 3) && (props.data.why4 || props.data.rootCause < 4) && (props.data.why5 || props.data.rootCause < 5)))
    const pacEnabledCorrectiveMeasures = computed(() => actionPlanTypeCorrectiveMeasures.value && (!fiveWhyMethodCorrectiveMeasuresEnabled.value || props.data.why6 && (props.data.why7 || props.data.rootCauseCorrectiveMeasures < 7) && (props.data.why8 || props.data.rootCauseCorrectiveMeasures < 8) && (props.data.why9 || props.data.rootCauseCorrectiveMeasures < 9) && (props.data.why10 || props.data.rootCauseCorrectiveMeasures < 10)))
    const userData = JSON.parse(localStorage.getItem('userData') || '{}')
    const actionPlans = ref(props.data.actionPlans || [])
    const actionPlansToDelete = []
    const approveAllEnabled = ref(false)
    const verifyAllEnabled = ref(false)
    const finalizeAllEnabled = ref(false)
    const approveAllCommentEnabled = ref(false)
    const verifyAllCommentEnabled = ref(false)
    const finalizeAllCommentEnabled = ref(false)
    const actionPlansToApprove = ref([])
    const actionPlansToVerify = ref([])
    const actionPlansToFinalize = ref([])
    const stages = { registration: 1, analysis: 3, approval: 4, corrective: 5, verification: 6, correctiveMeasures: 7, implementation: 8, finalized: 9, end: 10 }
    const complaintForm = ref(null)
    const updateActiveTab = ref(false)
    const tabMessages = ref({
      identificationTab: [],
      responsiblesTab: [],
      analysisTab: [],
      approvalTab: [],
      correctiveTab: [],
      verificationTab: [],
      correctiveMeasuresTab: [],
      implementationTab: [],
      finalizedTab: [],
    })
    const isTabMessagesPopulated = ref(false)
    const allActionPlansBeyondAnalysis = computed(() => actionPlans.value.every(e => e.stage !== "analysis"))
    const allActionPlansBeyondCorrectiveMeasures = computed(() => actionPlans.value.every(e => e.stage !== "correctiveMeasures"))
    const now = new Date()
    const endOfToday = new Date()
    endOfToday.setHours(23, 59, 59, 999)
    const destinationFolder = `${userData.client.$oid}/documents`
    const analysisActionPlans = computed(() => actionPlans.value.filter(e => e.stageCreated === "analysis"))
    const correctiveMeasuresActionPlans = computed(() => actionPlans.value.filter(e => e.stageCreated === "correctiveMeasures"))
    const tabs = [
      { title: i18n.t('message.identification'), name: 'identification', ref: identificationTab },
      { title: i18n.t('message.responsibles'), name: 'responsibles', ref: responsiblesTab },
      { title: i18n.t('message.analysis'), name: 'analysis', ref: analysisTab },
      { title: i18n.t('message.approval'), name: 'approval', ref: approvalTab },
      { title: i18n.t('complaintStages.corrective'), name: 'corrective', ref: correctiveTab },
      { title: i18n.t('message.verification'), name: 'verification', ref: verificationTab },
      { title: i18n.t('message.correctiveMeasures'), name: 'correctiveMeasures', ref: correctiveMeasuresTab },
      { title: i18n.t('message.implementation'), name: 'implementation', ref: implementationTab },
      { title: i18n.t('message.finalized'), name: 'finalized', ref: finalizedTab },
    ]

    const addMessage = (message) => {
      // Add message to the tab messages array
      tabMessages.value[message.tab].push(message)

      // Update complaint with new message
      emit('addNewMessage', message)
    }

    watch(props, () => {
      updateActiveTab.value = props.updateActiveTab
      actionPlans.value = props.data.actionPlans || []
      actionPlansToApprove.value = actionPlans.value.filter(e => e.stage === 'approval')
      actionPlansToVerify.value = actionPlans.value.filter(e => e.stage === 'verification')
      actionPlansToFinalize.value = actionPlans.value.filter(e => e.stage === 'finalized')
      if (stages[props.data.stage] > 4) approveAllCommentEnabled.value = true
      if (stages[props.data.stage] > 6) verifyAllCommentEnabled.value = true
      if (props.data.stage === 'end') finalizeAllCommentEnabled.value = true
      if (props.data.messages?.length && !isTabMessagesPopulated.value) {
        // Update this flag to populate messages only once
        isTabMessagesPopulated.value = true

        // Distribute messages to their respective tabs
        props.data.messages.forEach(message => {
          if (tabMessages.value[message.tab]) {
            message.createdAt = new Date(message.createdAt)
            tabMessages.value[message.tab].push(message)
          }
        })
      }
    })

    watch(updateActiveTab, () => {
      if (complaintForm.value && stages[props.data.stage]) {
        let activeTabIndex = Math.min(stages[props.data.stage] - 1, complaintForm.value.tabCount - 1)
        if (props.data.stage === 'corrective' && actionPlans.value.some(e => e.stage === 'verification')) {
          activeTabIndex = tabs.findIndex(t => t.name === 'verification')
        }
        complaintForm.value.activateTab(activeTabIndex)
        complaintForm.value.activeTabIndex = activeTabIndex
        complaintForm.value.maxStep = Math.max(activeTabIndex, 1)
        complaintForm.value.tabs.forEach((t, i) => t.checked = i <= Math.max(activeTabIndex, 1))
      }
    })

    watch(actionPlans, () => {
      actionPlans.value.forEach(e => {
        if (e.approvalResult === 'approved') e.approvalNextStage = e.type === 'immediate' ? 'verification' : 'corrective'
        if (e.correctiveResult === 'approved') e.correctiveNextStage = 'verification'
        if (e.verificationResult === 'approved') e.verificationNextStage = 'end'
        if (e.implementationResult === 'approved') e.implementationNextStage = 'finalized'
        if (e.finalizedResult === 'approved') e.finalizedNextStage = 'end'
        e.startDateConfig.maxDate = e.type === 'immediate' ? endOfToday : null
      })
    }, { deep: true })

    watch(actionPlansToApprove, () => {
      if (actionPlansToApprove.value.length && actionPlansToApprove.value.every(e => e.evidenceSeen || e.type === 'in_term')) {
        approveAllEnabled.value = true
      }
    })

    watch(actionPlansToVerify, () => {
      if (actionPlansToVerify.value.length && actionPlansToVerify.value.every(e => e.evidenceSeen)) {
        verifyAllEnabled.value = true
      }
    })

    watch(actionPlansToFinalize, () => {
      if (actionPlansToFinalize.value.length && actionPlansToFinalize.value.every(e => e.evidenceSeen)) {
        finalizeAllEnabled.value = true
      }
    })

    const activateEvidenceSelector = (index, stage) => {
      if (stage === 'analysis') {
        evidenceSelectorAnalysis.value[index].click()
      } else {
        evidenceSelectorCorrectiveMeasures.value[index].click()
        index += analysisActionPlans.value.length
      }
      evidenceIndex.value = index
    }

    const changeEvidenceSelected = (e) => {
      actionPlans.value[evidenceIndex.value].evidenceFile = Array.from(e.target.files)
    }

    const addActionPlan = (stageCreated) => {
      if (stageCreated === 'analysis' && !actionPlanType.value) return
      if (stageCreated === 'correctiveMeasures' && !actionPlanTypeCorrectiveMeasures.value) return
      actionPlans.value.push({
        name: '',
        description: '',
        startDate: JSON.parse(JSON.stringify(now)),
        endDate: JSON.parse(JSON.stringify(new Date(Date.now() + 7 * 24 * 60 * 60 * 1000))),
        startDateConfig: {
          ...flatPickrConfig,
          maxDate: stageCreated === 'analysis' ? (actionPlanType.value === 'immediate' ? endOfToday : null) : actionPlanTypeCorrectiveMeasures.value === 'immediate' ? endOfToday : null,
        },
        endDateConfig: {
          ...flatPickrConfig,
          minDate: JSON.parse(JSON.stringify(now)),
        },
        evidenceFile: [],
        type: stageCreated === 'analysis' ? actionPlanType.value : actionPlanTypeCorrectiveMeasures.value,
        executionResponsible: '',
        createdBy: userData.worker_id.$oid,
        stageCreated,
      })
    }
  
    const deleteActionPlan = (id, index) => {
      if (id) actionPlansToDelete.push(id)
      actionPlans.value.splice(index, 1)
    }

    const openCase = (id) => {
      const routeData = router.resolve({ name: 'organization-case-view', params: { id } });
      window.open(routeData.href, '_blank');
    }

    const handleCheck = (checked, index, stage) => {
      if (!checked) return

      // Uncheck all other action plans root causes checks
      actionPlans.value = actionPlans.value.map((e, i) => {
        const actionPlanCopy = { ...e }
        if (e.stageCreated === stage) {
          actionPlanCopy.isRootCause = i === index   // Set only the clicked one to true
        } else {
          index++
        }
        return actionPlanCopy
      })
    }

    // const formSubmitted = async () => {
    //   emit('isSubmitting')

    //   // Upload evidence files to AWS and then store evidence keys in an array
    //   for (const p of actionPlans.value) {
    //     if (!p.evidenceFile?.length) continue

    //     const uploadEvidencePromises = p.evidenceFile.map(file => {
    //       if (!file?.name) return null
    //       return new Promise((resolve, reject) => {
    //         singleUpload(file, destinationFolder)
    //           .then((key) => resolve(key))
    //           .catch((err) => {
    //             console.log(err)
    //             resolve(null)
    //           })
    //       })
    //     }) || []

    //     const evidenceKeys = await Promise.all(uploadEvidencePromises)

    //     p.evidenceKeys = evidenceKeys.filter(e => !!e)
    //   }

    //   const actionPlansCreationPromises = actionPlans.value.map((a, index) => {
    //     if (a._id) {
    //       if ((a.stage === 'analysis' || a.stage === 'correctiveMeasures') && (userData.worker_id.$oid === props.data.proposalResponsible || role === 'consultant')
    //         || a.stage === 'approval' && (userData.worker_id.$oid === props.data.approvalResponsible || role === 'consultant')
    //         || (a.stage === 'corrective' || a.stage === 'implementation') && (userData.worker_id.$oid === a.executionResponsible || props.data.verificationResponsible?.includes(userData.worker_id.$oid) || role === 'consultant')
    //         || (a.stage === 'verification' || a.stage === 'finalized') && (props.data.verificationResponsible?.includes(userData.worker_id.$oid) || role === 'consultant')
    //       ) {
    //         updateExistingActionPlan(a, props.data.stage)
    //       }
    //       return { _id: a._id, stageCreated: a.stageCreated, type: a.type }
    //     }

    //     return createNewActionPlan(a, index)
    //   })

    //   const newActionPlanIds = await Promise.all(actionPlansCreationPromises)

    //   const filteredIds = newActionPlanIds.filter(e => !!e).map(e => e._id)
    //   const correctiveMeasuresPlans = newActionPlanIds.filter(e => e?.stageCreated === 'correctiveMeasures')
      
    //   emit('submit', { ...props.data, actionPlansIds: filteredIds, actionPlansToDelete, correctiveMeasuresPlans })
    // }

    const createNewActionPlan = async (actionPlan, index) => {
      try {
        const newActionPlan = {
          client_id: oid(userData.client.$oid),
          createdBy: oid(actionPlan.createdBy),
          evidence_key: actionPlan.type === 'immediate' && actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null,
          executionResponsible: actionPlan.executionResponsible ? oid(actionPlan.executionResponsible) : null,
          name: actionPlan.name,
          description: actionPlan.description,
          type: actionPlan.type,
          startDate: date(formatDate(actionPlan.startDate)),
          endDate: actionPlan.type === 'in_term' ? date(formatDate(actionPlan.endDate)) : null,
          executionDate: actionPlan.type === 'immediate' ? date(formatDate(actionPlan.startDate)) : null,
          stage: actionPlan.stageCreated === 'analysis' ? 'approval' : actionPlan.type === 'in_term' ? 'implementation' : 'finalized',
          stageCreated: actionPlan.stageCreated,
          originIndex: index,
          isRootCause: actionPlan.isRootCause || false,
          complaint: oid(props.data._id),
          lastModifiedBy: oid(userData.worker_id.$oid),
          lastModifiedDate: date(new Date()),
        }

        const { insertedId } = await createItem({ collection: 'action_plan', payload: newActionPlan })
      
        // Send email to execution responsible with the details of the action plan created
        newActionPlan.originId = props.data._id
        // sendEmailActionPlan(newActionPlan, "add", 'executionResponsible', 'complaint')

        const newActionPlanId = insertedId.toString()
        newActionPlan._id = newActionPlanId

        createActionPlanEvent(newActionPlan)

        return {
          _id: newActionPlanId,
          stageCreated: actionPlan.stageCreated,
          type: actionPlan.type
        }
      } catch (error) {
        console.log(error)
        return null
      }
    }

    const updateExistingActionPlan = async (actionPlan, complaintStage) => {
      try {
        const query = { _id: oid(actionPlan._id) }

        let payload

        switch (actionPlan.stage) {
          case 'analysis':
            payload = {
              executionResponsible: actionPlan.executionResponsible ? oid(actionPlan.executionResponsible) : null,
              name: actionPlan.name,
              description: actionPlan.description,
              startDate: date(formatDate(actionPlan.startDate)),
              endDate: actionPlan.type === 'in_term' ? date(formatDate(actionPlan.endDate)) : null,
              stage: 'approval',
              approvalResult: '',
              approvalComment: '',
              isRootCause: actionPlan.isRootCause || false,
            }
            if (actionPlan.type === 'immediate') {
              payload.executionDate = date(formatDate(actionPlan.startDate))
              payload.evidence_key = actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null
            } else {
              payload.executionDate_unset = true
              payload.evidence_key_unset = true
            }
            break
          case 'approval':
            payload = {
              stage: actionPlan.approvalNextStage,
              approvalResult: actionPlan.approvalResult,
              approvalComment: actionPlan.approvalComment,
              correctiveResult: actionPlan.approvalNextStage === 'corrective' ? '' : null,
              correctiveComment: actionPlan.approvalNextStage === 'corrective' ? '' : null,
              verificationResult: actionPlan.approvalNextStage === 'verification' ? '' : null,
              verificationComment: actionPlan.approvalNextStage === 'verification' ? '' : null
            }
            break
          case 'corrective':
            const actionPlanExecutionDate = formatDate(actionPlan.executionDate)
            payload = {
              executionDate: date(actionPlanExecutionDate),
              stage: actionPlan.correctiveNextStage,
              evidence_key: actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null,
              correctiveResult: actionPlan.correctiveResult,
              correctiveComment: actionPlan.correctiveComment,
              verificationResult: actionPlan.correctiveNextStage === 'verification' ? '' : null,
              verificationComment: actionPlan.correctiveNextStage === 'verification' ? '' : null
            }
            updateActionPlanEvent(actionPlan._id, actionPlanExecutionDate)
            break
          case 'verification':
            if (complaintStage !== 'verification') break
            payload = {
              stage: actionPlan.verificationNextStage,
              verificationResult: actionPlan.verificationResult,
              verificationComment: actionPlan.verificationComment,
            }
            if (actionPlan.type === 'immediate' && actionPlan.verificationNextStage === 'analysis') {
              payload.evidence_key_unset = true
            }
            if (actionPlan.type === 'in_term' && actionPlan.verificationNextStage === 'corrective') {
              payload.correctiveResult = ''
              payload.correctiveComment = ''
              payload.executionDate_unset = true
              payload.evidence_key_unset = true
            }
            break
          case 'correctiveMeasures':
            payload = {
              executionResponsible: actionPlan.executionResponsible ? oid(actionPlan.executionResponsible) : null,
              name: actionPlan.name,
              description: actionPlan.description,
              startDate: date(formatDate(actionPlan.startDate)),
              endDate: actionPlan.type === 'in_term' ? date(formatDate(actionPlan.endDate)) : null,
              stage: actionPlan.type === 'in_term' ? 'implementation' : 'finalized',
              implementationResult: '',
              implementationComment: '',
              finalizedResult: actionPlan.type === 'immediate' ? '' : null,
              finalizedComment: actionPlan.type === 'immediate' ? '' : null
            }
            if (actionPlan.type === 'immediate') {
              payload.executionDate = date(formatDate(actionPlan.startDate))
              payload.evidence_key = actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null
            } else {
              payload.executionDate_unset = true
              payload.evidence_key_unset = true
            }
            break
          case 'implementation':
            payload = {
              executionDate: date(formatDate(actionPlan.executionDate)),
              stage: actionPlan.implementationNextStage,
              evidence_key: actionPlan.evidenceKeys?.length ? actionPlan.evidenceKeys : null,
              implementationResult: actionPlan.implementationResult,
              implementationComment: actionPlan.implementationComment,
              finalizedResult: actionPlan.implementationNextStage === 'finalized' ? '' : null,
              finalizedComment: actionPlan.implementationNextStage === 'finalized' ? '' : null
            }
            break
          case 'finalized':
            if (complaintStage !== 'finalized') break
            payload = {
              stage: actionPlan.finalizedNextStage,
              finalizedResult: actionPlan.finalizedResult,
              finalizedComment: actionPlan.finalizedComment,
            }
            if (actionPlan.type === 'immediate' && actionPlan.finalizedNextStage === 'correctiveMeasures') {
              payload.evidence_key_unset = true
            }
            if (actionPlan.type === 'in_term' && actionPlan.finalizedNextStage === 'implementation') {
              payload.implementationResult = ''
              payload.implementationComment = ''
              payload.executionDate_unset = true
              payload.evidence_key_unset = true
            }
            break
          default:
            break
        }

        if (!payload) return

        payload.lastModifiedBy = oid(userData.worker_id.$oid)
        payload.lastModifiedDate = date(new Date())

        const action = { $set: payload }

        await updateItem({ collection: 'action_plan', query, action })
      } catch (error) {
        console.log(error)
      }
    }

    const addEvidenceSeen = (actionPlanId, stage) => {
      if (stage === 'approval') {
        for (const actionPlan of actionPlansToApprove.value) {
          if (actionPlan._id === actionPlanId) {
            actionPlan.evidenceSeen = true
            actionPlansToApprove.value = [...actionPlansToApprove.value]
            break
          }
        }
      } else if (stage === 'verification') {
        for (const actionPlan of actionPlansToVerify.value) {
          if (actionPlan._id === actionPlanId) {
            actionPlan.evidenceSeen = true
            actionPlansToVerify.value = [...actionPlansToVerify.value]
            break
          }
        }
      } else {
        for (const actionPlan of actionPlansToFinalize.value) {
          if (actionPlan._id === actionPlanId) {
            actionPlan.evidenceSeen = true
            actionPlansToFinalize.value = [...actionPlansToFinalize.value]
            break
          }
        }
      }
    }

    const approveAllActionPlans = () => {
      approveAllCommentEnabled.value = true
      actionPlans.value.forEach(e => {
        if (e.stage === 'approval') e.approvalResult = 'approved'
      })
    }

    const verifyAllActionPlans = () => {
      verifyAllCommentEnabled.value = true
      actionPlans.value.forEach(e => {
        if (e.stage === 'verification') e.verificationResult = 'approved'
      })
    }

    const finalizeAllActionPlans = () => {
      finalizeAllCommentEnabled.value = true
      actionPlans.value.forEach(e => {
        if (e.stage === 'finalized') e.finalizedResult = 'approved'
      })
    }

    const formatKey = (keys) => {
      // return key ? key.slice(key.indexOf('-') + 1) : i18n.t('message.no_evidence_attached')
      return keys?.length ? `${keys.length} ${i18n.t('evidence')}${keys.length > 1 ? 's' : ''}` : i18n.t('message.no_evidence_attached')
    }

    const validateTab = (tabRef, tabName) => new Promise((resolve, reject) => {
      if (role !== 'consultant' && (
          (tabName === 'analysis' || tabName === 'correctiveMeasures') && userData.worker_id.$oid !== props.data.proposalResponsible
          || tabName === 'approval' && userData.worker_id.$oid !== props.data.approvalResponsible
          || (tabName === 'verification' || tabName === 'finalized') && props.data.verificationResponsible?.includes(userData.worker_id.$oid)
        )
      ) {
        resolve(true)
      } else {
        tabRef.value.validate().then(success => {
          if (success) {
            // Validate that every 'immediate' (in stage 'analysis') and 'in term' (in stage 'corrective'/'implementation') action plans have an evidence selected to upload
            for (const actionPlan of actionPlans.value) {
              if ((actionPlan.type === 'immediate' && (tabName === 'analysis' || tabName === 'correctiveMeasures')
                || actionPlan.type === 'in_term' && (userData.worker_id.$oid === actionPlan.executionResponsible || props.data.verificationResponsible?.includes(userData.worker_id.$oid) || role === 'consultant')
                && (tabName === 'corrective' && actionPlan.stage === 'corrective' && actionPlan.correctiveNextStage === 'verification'
                || tabName === 'implementation' && actionPlan.stage === 'implementation' && actionPlan.implementationNextStage === 'finalized'))
                && !actionPlan.evidenceFile?.length && !actionPlan.evidence_key?.length && !props.readOnly) {
                  console.log("not validated", actionPlan)
                  return reject()
              }
            }
            resolve(true)
          }
          else {
            reject()
          }
        })
      }
    })

    // Watch for action plans start dates to update end dates for 'in_term' action plans
    watch(
      () => actionPlans.value.map(p => p.startDate),
      (newStartDates, oldStartDates) => {

        // If the lengths are different, we cannot compare them
        if (newStartDates.length !== oldStartDates?.length) return

        actionPlans.value.forEach((item, index) => {
          const newStart = newStartDates[index]
          const oldStart = oldStartDates[index]

          if (item.type === 'in_term' && newStart && formatDateAsYMD(formatDate(newStart)) !== formatDateAsYMD(formatDate(oldStart))) {
            const end = formatDate(newStart)
            end.setDate(end.getDate() + 7)
            item.endDate = end
            item.endDateConfig.minDate = item.startDate || null
          }
        })
      },
      { immediate: true }
    )

    const goToPreviousTab = () => {
      if (complaintForm.value) {
        complaintForm.value.prevTab()
      }
    }

    const goToNextTab = async () => {
      const index = complaintForm.value.activeTabIndex

      try {
        await validateTab(tabs[index].ref, tabs[index].name)
        complaintForm.value.nextTab()
      } catch (err) {
        // Error de validación, no avanza
      }
    }

    const validateAllTabs = async () => {
      const wizard = complaintForm.value

      for (let i = 0; i < wizard.tabs.length; i++) {
        try {
          await validateTab(tabs[i].ref, tabs[i].name)
        } catch (error) {
          const failedTab = wizard.tabs[i]
          const tabTitle = failedTab.title

          if (i !== wizard.activeTabIndex) {
          }
          
          throw error
        }
      }
    }

    const handleSubmit = async () => {
      try {
        await validateAllTabs()
        formSubmitted()
      } catch (error) {
        // Si alguna validación falla, no enviamos
      }
    }

    const formatDate = (date, hour = 12) => {
      let formattedDate;

      if (date instanceof Date || date.includes("T")) {
        // ISO 8601 format (e.g. 2025-01-17T15:00:00.000Z)
        formattedDate = new Date(date);
        formattedDate.setHours(hour, 0, 0, 0);
      } else if (/^\d{4}-\d{2}-\d{2}$/.test(date)) {
        // yyyy-mm-dd format
        const [year, month, day] = date.split("-").map(Number);
        formattedDate = new Date(year, month - 1, day, hour, 0);
      } else {
        // dd-mm-yyyy or dd-mm-yyyy hh:mm
        const [datePart, timePart] = date.split(" ");
        const [day, month, year] = datePart.split("-").map(Number);
        const [hours, minutes] = timePart ? timePart.split(":").map(Number) : [hour, 0];
        formattedDate = new Date(year, month - 1, day, hours, minutes);
      }

      return formattedDate;
    };

    const getBusinessDays = (start, end) => {
      if (!start || !end) return null

      let count = 0
      const current = formatDate(start)
      const last = formatDate(end)

      // Normalizar horas
      current.setHours(0,0,0,0)
      last.setHours(0,0,0,0)

      while (current < last) {
        const day = current.getDay()
        if (day !== 0 && day !== 6) count++ // 0 domingo, 6 sábado
        current.setDate(current.getDate() + 1)
      }

      return count
    }

    const proposalBusinessDays = computed(() => {
      return getBusinessDays(props.data?.createdAt, props.data?.dueDate)
    })

    const approvalBusinessDays = computed(() => {
      return getBusinessDays(props.data?.createdAt, props.data?.approvalDueDate)
    })

    const verificationBusinessDays = computed(() => {
      return getBusinessDays(props.data?.createdAt, props.data?.verificationDueDate)
    })

    onMounted(() => {
      if (props.readOnly) return

      // getWorkersTotalForDropDown()
      // getImprovementsForDropDown()
      // getLocationsForDropDown()

      // Populate messages
      if (props.data.messages?.length && !isTabMessagesPopulated.value) {
        // Update this flag to populate messages only once
        isTabMessagesPopulated.value = true

        // Distribute messages to their respective tabs
        props.data.messages.forEach(message => {
          if (tabMessages.value[message.tab]) {
            message.createdAt = new Date(message.createdAt)
            tabMessages.value[message.tab].push(message)
          }
        })
      }

      // Update next stages if it is approved
      actionPlans.value.forEach(e => {
        if (e.approvalResult === 'approved') e.approvalNextStage = e.type === 'immediate' ? 'verification' : 'corrective'
        if (e.correctiveResult === 'approved') e.correctiveNextStage = 'verification'
        if (e.verificationResult === 'approved') e.verificationNextStage = 'end'
        if (e.implementationResult === 'approved') e.implementationNextStage = 'finalized'
        if (e.finalizedResult === 'approved') e.finalizedNextStage = 'end'
        e.startDateConfig.maxDate = e.type === 'immediate' ? endOfToday : null
      })

      // If the why method is being used, enable it so it is printed
      if (props.data.why1) fiveWhyMethodEnabled.value = true
      if (props.data.why6) fiveWhyMethodCorrectiveMeasuresEnabled.value = true
    })

    return {
      workersTotal,
      improvements,
      locations,
      companies,
      required,
      form,
      openDocument,
      noDocumentMessage,
      evidenceSelectorAnalysis,
      evidenceSelectorCorrectiveMeasures,
      activateEvidenceSelector,
      changeEvidenceSelected,
      openCase,
      stateOptions,
      actionPlanOptions,
      resultOptions,
      correctiveResultOptions,
      inTermApprovalStageComplaintOptions,
      correctiveStageOptions,
      immediateVerificationStageOptions,
      inTermVerificationStageComplaintOptions,
      implementationStageOptions,
      immediateFinalizedStageOptions,
      inTermFinalizedStageOptions,
      // formSubmitted,
      validateTab,
      identificationTab,
      responsiblesTab,
      analysisTab,
      approvalTab,
      correctiveTab,
      verificationTab,
      correctiveMeasuresTab,
      implementationTab,
      finalizedTab,
      actionPlanType,
      actionPlanTypeCorrectiveMeasures,
      addActionPlan,
      deleteActionPlan,
      pacEnabled,
      pacEnabledCorrectiveMeasures,
      actionPlans,
      userData,
      approveAllEnabled,
      verifyAllEnabled,
      finalizeAllEnabled,
      approveAllCommentEnabled,
      verifyAllCommentEnabled,
      finalizeAllCommentEnabled,
      addEvidenceSeen,
      approveAllActionPlans,
      verifyAllActionPlans,
      finalizeAllActionPlans,
      stages,
      complaintForm,
      formatKey,
      fiveWhyMethodEnabled,
      fiveWhyMethodCorrectiveMeasuresEnabled,
      tabMessages,
      addMessage,
      allActionPlansBeyondAnalysis,
      allActionPlansBeyondCorrectiveMeasures,
      flatPickrConfig,
      inputFileTypes,
      analysisActionPlans,
      correctiveMeasuresActionPlans,
      role,
      handleCheck,
      goToPreviousTab,
      goToNextTab,
      handleSubmit,
      actionPlanNames,
      actionPlanNamesCorrectiveMeasures,
      proposalBusinessDays,
      approvalBusinessDays,
      verificationBusinessDays,
    }
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-wizard.scss";
@import "@core/scss/vue/libs/vue-select.scss";
</style>

<style lang="scss" scoped>
@import '~@core/scss/base/bootstrap-extended/include';

.custom-mt {
  margin-top: 5px;
}

.rounded.border-primary,
.rounded.border-warning {
  border-width: 3px !important;
}

.early-finish-notice {
  border: 3px solid #ff9f43;
  background-color: #fff8f1;
  padding: 1.5rem;
  border-radius: 0.5rem;
  box-shadow: 0 4px 8px rgba(255, 159, 67, 0.2);

  h5 {
    color: #ff6b00;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.5px;
  }

  .form-group label {
    font-weight: 600;
    color: #333;
  }

  .print-text {
    font-size: 1rem;
    line-height: 1.5;
    color: #444;
  }
}

@media print {
  .early-finish-notice {
    border: 3px solid #000;
    background-color: #f0f0f0;
    page-break-inside: avoid;
  }
}
</style>